import {useCallback, useState} from "react";
import {createUrl} from "../config";
import {ApiError} from "../models/ApiError";
import {parseApiError} from "./utils";
import {User} from "../models/User";
import {useAuthenticatedUserContext} from "../services/authenticatedUser/AuthenticatedUserContext";

type useSignInReturnType = [
    (email: string, password: string) => Promise<void>,
    {
        loading: boolean;
        error?: ApiError
    }
];

export function useSignIn(): useSignInReturnType {
    const [error, setError] = useState<ApiError | undefined>();
    const [loading, setLoading] = useState(false);
    const {setAuthenticatedUser} = useAuthenticatedUserContext();
    const signIn = useCallback((email: string, password: string) => {
        return new Promise<void>((resolve, reject) => {
            setLoading(true);
            setError(undefined);
            fetch(createUrl('/v1/api/users.signIn'), {
                method: 'POST',
                credentials: 'include',
                body: JSON.stringify({
                    email,
                    password
                })
            }).then(response => {
                if (response.status === 200) {
                    setLoading(false);
                    response.json().then(body => {
                        setAuthenticatedUser(parseUser(body));
                        resolve();
                    });
                    return;
                }
                response.json().then(body => {
                    const apiError = parseApiError(body);
                    setError(apiError);
                    setLoading(false);
                    reject(apiError);
                });
            }).catch(reason => {
                setLoading(false);
                const apiError = new ApiError('UNKNOWN', reason.toString());
                setError(apiError);
                reject(apiError);
            });
        });
    }, [setAuthenticatedUser]);
    return [signIn, {error, loading}]
}

function parseUser(body: any): User {
    return body.data.user;
}
